<template>
    <v-container>
    <field-form @save="create" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" @cancel="cancelWizard()" @click-step="changeStep">
    <h4 class="text-h4">{{$t('campaigns.name.title')}}</h4>
    <p>{{$t('campaigns.name.text')}}</p>
    <v-text-field id="pfid1618852644" dense v-model="name" :placeholder="$t('campaigns.name.title')" :rules="[v=> !!v || $t('form.rules.required')]"></v-text-field>
    <h4 class="text-h4 d-none d-md-block">{{$t('campaigns.mediumAndType.title')}}</h4>
    <p>{{$t('campaigns.mediumAndType.text')}}</p>
    <v-row id="pfid1618852677" justify="space-between">
      <v-col id="pfid1618852695" cols="12" md="6" lg="4">
        <h4 class="text-h4 d-block d-md-none">{{$t('campaigns.mediumAndType.medium')}}</h4>
        <v-card class="mb-3" link :disabled="!t.active" :color="medium == t.value ? 'primary' : null" :dark="medium == t.value" @click="medium = t.value" v-for="t in media" :key="t.value">
          <v-badge overlap tile v-if="!t.active" color="success" :content="$t('common.comingSoon')"></v-badge>
          <v-card-title color="primary">{{t.title}}</v-card-title>
          <v-card-text>{{t.text}}</v-card-text>
        </v-card>
      </v-col>
      <v-col id="pfid1618852712" cols="12" md="6" lg="4">
        <h4 class="text-h4 d-block d-md-none">{{$t('campaigns.mediumAndType.type')}}</h4>
        
        <v-card class="mb-3" link :disabled="!t.active" :color="type == t.value ? 'primary' : null" :dark="type == t.value" @click="type = t.value" v-for="t in types" :key="t.value">
          <v-badge overlap tile v-if="!t.active" color="success" :content="$t('common.comingSoon')"></v-badge>
          <v-card-title color="primary">{{t.title}}</v-card-title>
          <v-card-text>{{t.text}}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    </field-form>
    </v-container>
</template>
<script>

  import { mapState } from "vuex";
  import FieldForm from '@/components/FieldForm';
  import ParseRoute from '@/mixins/parse-route';
  import Wizards from '@/mixins/wizards';

  export default {
    name: 'CampaignType',
    components: {FieldForm},
    mixins: [Wizards, ParseRoute],
    data() {
      return {
        name: null,
        saving: false,
        medium: 'EMAIL',
        type: this.$route.params.type == 'btc' ? 'BACK_TO_CART' : this.$route.params.type == 'swu' ? 'SMART_WARM_UP' : this.$route.params.type?.toUpperCase(),
        media: [
          {title: this.$t('media.email'), text: this.$t('campaigns.media.email.text'), value: 'EMAIL', active: true },
          {title: this.$t('media.push'), text: this.$t('campaigns.media.push.text'), value: 'PUSH', active: false },
          {title: this.$t('media.sms'), text: this.$t('campaigns.media.sms.text'), value: 'SMS', active: false },
          {title: this.$t('media.letter'), text: this.$t('campaigns.media.letter.text'), value: 'LETTER', active: false },
        ],
        types: [
          {title: this.$t('campaigns.scheduled.title'), text: this.$t('campaigns.scheduled.text'), value: 'SCHEDULED', active: true },
          {title: this.$t('campaigns.automatic.title'), text: this.$t('campaigns.automatic.text'), value: 'AUTOMATIC', active: true },
          {title: this.$t('campaigns.btc.title'), text: this.$t('campaigns.btc.text'), value: 'BACK_TO_CART', active: true },
          {title: this.$t('campaigns.swu.title'), text: this.$t('campaigns.swu.text'), value: 'SMART_WARM_UP', active: true },
          {title: this.$t('campaigns.welcome.title'), text: this.$t('campaigns.welcome.text'), value: 'WELCOME', active: true },
          {title: this.$t('campaigns.repeated.title'), text: this.$t('campaigns.repeated.text'), value: 'REPEATED', active: false },
          {title: this.$t('campaigns.personal.title'), text: this.$t('campaigns.personal.text'), value: 'PERSONAL', active: false },
        ],
      };
    },
    computed: {
      readOnly() {
        return this.$route.name == 'campaigns-add'
      },
      wizardParams() {
        return {};
      },
      ...mapState("domains", ["item"]),
      ...mapState("campaigns", ["listAutomatic"])
    },
    methods: {
      async create() {
        let segment = {};
        if(this.$route.query.tagId) {
          segment.segmentationType = 'TAG';
          segment.segment = { tagId: this.$route.query.tagId };
        }
        let c = await this.$store.dispatch('campaigns/create', { fields: {
          name: this.name,
          scheduleType: this.type,
          medium: this.medium,
          priority: this.type == 'AUTOMATIC' ? this.computePriority() : 0,
          ...segment
          //medium: this.medium
          },
          domain: this.item
        });
        this.nextStep({ campaign: c.id });
      },
      computePriority() {
        if(!this.listAutomatic || this.listAutomatic.length == 0) {
          return 10000;
        } else {
          return Math.ceil(this.listAutomatic[this.listAutomatic.length - 1].priority / 2);
        }
      }
    },
    created() {
      this.$store.commit('ui/wizard', {value: true });
      if(!this.listAutomatic) {
        this.$store.dispatch('campaigns/list', { domainID: this.domain, sortDirection: 'DESC' })
      }
    }
  }
</script>